import React, { Component } from 'react';
import { View, Text } from 'react-native';
import { ReactComponent as HomeLogo } from '../../../assets/home-logotype.svg';
import { ReactComponent as Stars } from '../../../assets/stars.svg';

type Props = {};

export default class Help extends Component<Props> {
  render() {
    return (
      <View
        style={{
          flex: 1,
          width: '100%',
          height: '100%',
          alignItems: 'center',
          backgroundColor: '#201F4A'
        }}
      >
        <HomeLogo />
        <View
          style={{
            flex: 1,
            width: '100%',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Text style={{ color: 'white', fontSize: 20 }}>
            For support please contact:
          </Text>
          <a href={`mailto:appledeveloper@saltshakerholdings.com`}>
            <Text style={{ color: 'white', fontSize: 20 }}>
              appledeveloper@saltshakerholdings.com
            </Text>
          </a>
        </View>
      </View>
    );
  }
}
